import {Directive, forwardRef} from '@angular/core';
import {NG_VALIDATORS} from '@angular/forms';
import {validateIban} from '@atlas/businesstypes';

import {AbstractValidatorDirective} from '../base/validator';

/**
 * @ngModule BusinessTypesModule
 */
@Directive({
  selector: '[atlasIban]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => BaseIbanValidator),
      multi: true,
    },
  ],
})
export class BaseIbanValidator extends AbstractValidatorDirective {
  protected readonly validatorFn = validateIban;
}
